module.exports = __webpack_public_path__ + "static/SFMada-8a47bdcf15a9bc985f1906ead502183d.ttf";